import { Injectable, Optional, Inject } from '@angular/core';
import { 
  ComboboxTranslations, 
  ComboboxTranslationInput 
} from './combobox-translations.interface';
import { DEFAULT_COMBOBOX_TRANSLATIONS } from './combobox-translations.defaults';
import { GERMAN_COMBOBOX_TRANSLATIONS } from './combobox-translations.de';
import { GenericTranslationService } from '../../services/generic-translation.service';
import { 
  ComponentConfig, 
  createComponentConfigToken, 
  createConfigProvider 
} from '../../services/translation-config.helper';

/**
 * Configuration for Combobox translations
 */
export interface ComboboxConfig extends ComponentConfig<ComboboxTranslations> {}

/**
 * Injection token for Combobox configuration
 */
export const COMBOBOX_CONFIG = createComponentConfigToken<ComboboxTranslations>('COMBOBOX_CONFIG');

/**
 * Service for managing Combobox translations
 * Extends GenericTranslationService with Combobox-specific configuration
 */
@Injectable({
  providedIn: 'root'
})
export class ComboboxTranslationService extends GenericTranslationService<ComboboxTranslations> {
  
  constructor(
    @Optional() @Inject(COMBOBOX_CONFIG) config?: ComboboxConfig
  ) {
    super(DEFAULT_COMBOBOX_TRANSLATIONS);
    
    // Register available languages
    this.registerLanguage('de', GERMAN_COMBOBOX_TRANSLATIONS);
    
    // Initialize with config translations if provided
    if (config?.translations) {
      this.setGlobalTranslations(config.translations);
    }
  }
}

/**
 * Provider for global Combobox configuration
 * Usage in app.module.ts:
 * 
 * providers: [
 *   ComboboxConfigProvider.forRoot({
 *     translations: myTranslations
 *   })
 * ]
 */
export const ComboboxConfigProvider = createConfigProvider<ComboboxTranslations>(COMBOBOX_CONFIG);
